<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <!-- <div class="card-header">
            <div class="row">
              <div class="col-10 col-sm-10">
                <h4>Notification Blogs</h4>
              </div>
            </div>
          </div> -->
          <div class="card-body p-2">
            <template v-for="(notification, idx_notification) in notificationBlogsList.rows">
              <div class="m-4" :key="idx_notification">
                <template v-if="notification.type === 'notifications_blogs'">
                  <div class="cursor-pointer" @click="navigateNotification(notification)">
                    <p class="font-weight-bold mb-2">{{ notification.tags }}</p>
                    <h3 class="mb-2">{{ notification.header }}</h3>
                    <p class="mb-2" style="font-size: 20px;">{{ notification.sub_header }}</p>
                    <p>{{ formatDate(notification.published_at) }}</p>
                  </div>
                </template>
                <template v-if="notification.type === 'leads'">
                  <div class="cursor-pointer" @click="navigateNotification(notification)">
                    <p class="font-weight-bold mb-2">{{ notification.leads_board.steps.label }}</p>
                    <h3 class="mb-2"><span style="color: #1868db;">{{ notification.user.name }}</span> commented on a leads</h3>
                    <p class="mb-2" style="font-size: 20px;">{{ notification.leads_board.name }}</p>
                    <p>{{ formatDate(notification.published_at) }}</p>
                  </div>
                </template>
                <hr v-if="idx_notification !== notificationBlogsList.rows.length - 1" />
              </div>
            </template>
          </div>
          <b-pagination class=" ml-4" v-if="notificationBlogsList.total_row > notificationBlogsList.per_page" v-model="currentNotificationBlogsPage" :total-rows="notificationBlogsList.total_row" :per-page="notificationBlogsList.per_page"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import moment from 'moment';
import blogsNotifApi from '../../api/blogNotif';
import popupErrorMessages from '../../library/popup-error-messages';

export default {
  name: 'Notification Blogs',
  metaInfo: {
    title: 'Notification Blogs',
  },
  data() {
    return {
      moment,
      loading: {
        detail: false,
        list: false,
      },
      form: {
        header: '',
        sub_header: '',
        description: '',
        tags: 'News',
        published_at: '',
        published_stop: '',
        video: '',
      },
      tags: ['News', 'Announcement'],
      loader: null,
      loaderStack: 0,
      notificationBlogsList: {
        page: 1,
        per_page: 20,
        rows: [],
        total_row: 0,
      },
    };
  },
  validations() {
    return {
      form: {
        header: { required },
        sub_header: { required },
        description: { required },
        tags: { required },
        published_at: { required },
        published_stop: {},
        video: {},
      },
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  computed: {
    userProfile() {
      return this.$store.state.auth.userProfile || {};
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    checkPermission() {
      const users = this.$store.state.backOffice.userProfile;
      const path = this.$router.currentRoute.fullPath;
      const permission = users.permissions.find((v) => path.includes(v.path));
      return permission.configuration;
    },
    currentNotificationBlogsPage: {
      get() {
        return this.notificationBlogsList.page;
      },
      set(val) {
        this.notificationBlogsList.page = val;
        this.loadNotificationNews();
      },
    },
  },
  mounted() {
    this.loadNotificationNews();
  },
  methods: {
    navigateNotification(notification) {
      let route;
      if (notification.type === 'notifications_blogs') {
        route = {
          name: 'Detail Notification Blogs',
          params: { id: notification._id },
        };
      } else if (notification.type === 'leads') {
        route = {
          name: 'LeadsCard',
          params: { id: notification.leads_board.id },
          hash: '#leads-comments',
        };
      }
      if (this.$route.name !== route.name || this.$route.params.id !== route.params.id) {
        // visit page and scroll
        this.$router.push(route).then(() => {
          if (route.hash) {
            const el = document.querySelector(route.hash);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }
        });
      } else if (route.hash) {
        // same page and scroll
        const el = document.querySelector(route.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async loadNotificationNews() {
      this.loading.list = true;
      const response = await blogsNotifApi.getNotificationNewsList(this.activeWorkspace._id, { page: this.notificationBlogsList.page, per_page: this.notificationBlogsList.per_page });
      await popupErrorMessages(response);
      this.notificationBlogsList.rows = response.data.rows;
      this.notificationBlogsList.total_row = response.data.count;
      this.loading.list = false;
    },
    formatDate(date) {
      return moment(date).format('YYYY MMM DD');
    },
  },
};
</script>
<style>
  .preview-content img, .preview-content video {
    max-width: 100%;
    height: auto;
    max-height: 200px;
    object-fit: contain;
    display: block;
  }
</style>
